import React, { useState, useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';



import fondo from '../../assets/img/landingPage/fondo.png';


import features_1 from '../../assets/img/landingPage/brunix/Brunix_01.png'
import features_2 from '../../assets/img/landingPage/brunix/Brunix_02.png'
import features_3 from '../../assets/img/landingPage/brunix/Brunix_03.png'


import home_img from '../../assets/img/landingPage/brunix/home.png'

import logo from '../../assets/img/logos/AVAP_AI_white.svg'
import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'
import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'

import img_ai1 from '../../assets/img/landingPage/ContextualMemory_0.5.png'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

const BrunixProduct = () => {

    const [selectedFeature, setSelectedFeature] = useState('realTime');

    let imageSrc;
    let imageAlt = '';
    if (selectedFeature === 'realTime') {
        imageSrc = features_1;
        imageAlt = "Illustration of BRUNIX AI at the center representing ongoing conversations, tracking all interactions with AVAP and user context.";
    } else if (selectedFeature === 'askQuestions') {
        imageSrc = features_2;
        imageAlt = "Illustration with BRUNIX AI at the center surrounded by features that enable it to understand AVAP language and specific development capabilities.";
    } else if (selectedFeature === 'organizedThread') {
        imageSrc = features_3;
        imageAlt = "Brunix AI at the top analyzing comments within code, identifying workflow patterns, flagging issues, suggesting solutions, and recommending optimizations.";
    }


    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);

        // clean favicon 
        return () => {
            document.head.removeChild(link);
        };
    }, []);


    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);



    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo Brunix AI"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Artificial Intelligence where you are the copilot</h1>
                    <p className="fl-subtitle">
                        Integrated into the core of AVAP, efficiency <br />  and productivity in API development.
                    </p>
                    {/*<a className="glowBtn-dark fakeHide" href="#"><span className="btnInner">  Start with AVAP Cloud</span></a>*/}


                </section>

                {/* Powerful API Platform */}
                <section className="text-center container pb-8">
                    <div className="row">
                        <div className="col">

                            <img
                                src={home_img}
                                alt="Illustration of BRUNIX AI at the center forming connections and facilitating conversations, symbolizing intelligent orchestration and collaboration."
                                className="img-fluid mb-4"
                                style={{ width: '70%', maxWidth: '900px', height: 'auto' }}
                            />
                            <h2 className="fl-subtitle pt-8">Transforming AI-Driven API Lifecycle Management
                            </h2>
                            <p className="fl-text">
                                Brunix is an AI-driven engine optimizing the entire API lifecycle. From development to scaling, it automates processes, enhances infrastructure, and drives smarter decisions with real-time insights.
                                <br /><br />
                                Seamlessly integrated into AVAP, Brunix leverages deep context to deliver precise recommendations and automated optimizations. As a process orchestrator, it accelerates API development, strengthens security, and maximizes efficiency.

                            </p>
                        </div>
                    </div>
                </section>

                {/* AI */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 pl-5">
                            <h3 className="fl-title">AI-driven development</h3>
                            <div className="pills" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <div
                                    className={`fl-darkButton fl-centered-btn ${selectedFeature === 'realTime' ? 'active' : ''}`}
                                    onClick={() => setSelectedFeature('realTime')}
                                    style={{ cursor: 'pointer' }}
                                >
                                    Real-time conversations
                                </div>
                                <div
                                    className={`fl-darkButton fl-centered-btn ${selectedFeature === 'askQuestions' ? 'active' : ''}`}
                                    onClick={() => setSelectedFeature('askQuestions')}
                                    style={{ cursor: 'pointer' }}
                                >
                                    Ask questions and brainstorm collaboratively
                                </div>
                                <div
                                    className={`fl-darkButton fl-centered-btn ${selectedFeature === 'organizedThread' ? 'active' : ''}`}
                                    onClick={() => setSelectedFeature('organizedThread')}
                                    style={{ cursor: 'pointer' }}
                                >
                                    Organized discussion thread
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 text-center">
                            <img
                                src={imageSrc}
                                alt={imageAlt}
                                className="img-fluid"
                            />
                        </div>
                    </div>
                </section>

                <div className="w-100 fl-divider" style={{ backgroundImage: `url(${dividerbg})` }}>

                </div>

                <section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="fl-title text-center mb-5">Artificial Intelligence is in our DNA
                            </div>
                        </div>
                    </div>
                </section>

                {/* asd */}
                

                <div className="bottomWrapper position-relative d-flex justify-content-center">
                    <img src={gradientbottom} alt="" className="gradient gradientBottom opacity-5" />
                    <section className="container py-5 gradient-d fl-br-20 mt-5 mb-8">
                        <div className="row align-items-center">

                            <div className="col-md-4 text-center">
                                <img
                                    src={features_1}
                                    alt="Illustration of BRUNIX AI at the center representing ongoing conversations, tracking all interactions with AVAP and user context."
                                    className="img-fluid"
                                />
                            </div>

                            <div className="col-md-8 pl-5 pr-5">
                                <span className="fl-label">Key Features</span>
                                <h3 className="fl-subtitle">Multi-AI Integration for Enhanced Services</h3>
                                <p className="fl-text">
                                Brunix leverages not only our proprietary AI models but also integrates seamlessly with top-tier AI systems. This multi-AI approach enhances the functionality of our platform by offering additional services and capabilities, allowing for smarter, data-driven decisions. Our data model is complemented with an external layer of integrations, ensuring that Brunix can adapt to the best AI technologies and provide optimal solutions across various contexts.
                                </p>
                            </div>
                        </div>
                    </section>
                </div>

                {/* Comprehensive API Management */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-8 pl-5 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Intelligent Process Optimization</h3>
                            <p className="fl-text">
                            Brunix actively improves your development pipeline. By analyzing coding patterns, deployment data, and infrastructure performance, it automatically suggests efficiency improvements, optimizes API integrations, and streamlines redundant tasks. This proactive approach reduces time-to-market, enhances team productivity, and minimizes operational overhead.
                            </p>
                        </div>
                        <div className="col-md-4 text-center">
                            <img
                                src={features_2}
                                alt="Illustration with BRUNIX AI at the center surrounded by features that enable it to understand AVAP language and specific development capabilities."
                                className="img-fluid"
                            />
                        </div>

                    </div>
                </section>


                
                {/* Beyond a Proxy */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-4 text-center">
                            <img
                                src={features_3}
                                alt="Brunix AI at the top analyzing comments within code, identifying workflow patterns, flagging issues, suggesting solutions, and recommending optimizations."
                                className="img-fluid"
                            />
                        </div>

                        <div className="col-md-8 pl-5 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Contextual Memory</h3>
                            <p className="fl-text">
                                Brunix maintains a rich, continuous memory of your entire development process.
                                Unlike traditional AI systems, Brunix tracks all interactions and incorporates
                                ongoing conversations, the specific AVAP context, and user-provided personal contexts.
                                This allows Brunix to deliver highly relevant, tailored support that
                                evolves with your project, providing more accurate suggestions and helping you troubleshoot more effectively.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default BrunixProduct;
